const THEME = {
  GENERIC: "generic",
};

export default THEME;
